/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Listingbuttonsmoveup3Inputs */

const en_listingbuttonsmoveup3 = /** @type {(inputs: Listingbuttonsmoveup3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.label} up`)
};

const de_listingbuttonsmoveup3 = /** @type {(inputs: Listingbuttonsmoveup3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} nach oben`)
};

/**
* | output |
* | --- |
* | "Move {label} up" |
*
* @param {Listingbuttonsmoveup3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmoveup3 = /** @type {((inputs: Listingbuttonsmoveup3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmoveup3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmoveup3(inputs)
	return de_listingbuttonsmoveup3(inputs)
});
export { listingbuttonsmoveup3 as "listingButtonsMoveUp" }